import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { TilesValuesFragmentFragmentDoc } from '@packages/gql/generated/shopping/TilesValuesFragmentFragmentDoc';
import { useRouter } from 'next/navigation';
import { getIsAvailable } from '../../helpers/getIsAvailable/getIsAvailable';
import type { SetSelectedVariation } from '../../types/types';
import { useVariationFormattedLink } from '../utils/useVariationFormattedLink';
import { TileButton } from './TileButton/TileButton';
import { getStyle } from './getStyle/getStyle';

/* GraphQL */ `
  fragment TilesValuesFragment on ProductDimension {
    values {
      displayText
      isSelected
      sku
      availability {
        state
      }
    }
  }
`;

export type TilesDimensionProps = {
  /**
   * The GraphQL dimension data for the given product
   */
  dimensionData: FragmentType<typeof TilesValuesFragmentFragmentDoc>;
  onChange?: SetSelectedVariation;
};

/**
 * TilesDimension to choose a product variation on Detailview
 * */
export const TilesDimension = ({ dimensionData, onChange }: TilesDimensionProps) => {
  const dimension = getFragmentData(TilesValuesFragmentFragmentDoc, dimensionData);
  const { push } = useRouter();
  const createVariationLink = useVariationFormattedLink();

  return (
    <div className="flex flex-wrap gap-1.5">
      {dimension.values.map(({ sku, displayText, availability, isSelected }) => {
        if (!sku) {
          return null;
        }

        return (
          <TileButton
            key={`tilebtn${sku}`}
            sku={sku}
            active={!!isSelected}
            sx={getStyle(getIsAvailable(availability), !!isSelected)}
            size="medium"
            onClick={() => {
              if (onChange) {
                onChange(sku);
              } else {
                push(createVariationLink(sku));
              }
            }}
          >
            {displayText}
          </TileButton>
        );
      })}
    </div>
  );
};
